import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import axios from 'axios';
import { Provider } from 'react-redux';
import store from './store';

// Global interceptor: emit points:deducted when the API deducts points (incl. scheduled sends)
axios.interceptors.response.use((response) => {
	try {
		const url = response?.config?.url || '';
		if (url.includes('/api/users/deduct-points') && response?.data) {
			const remaining = response.data.remainingPoints;
			if (typeof window !== 'undefined' && typeof remaining === 'number') {
				window.dispatchEvent(new CustomEvent('points:deducted', { detail: { remainingPoints: remaining } }));
			}
		}
	} catch (_) {}
	return response;
}, (error) => Promise.reject(error));

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
); 